// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleGroupManifest } from '@platform/core/types/modularity/IModuleGroupManifest';
import { consultationSubmissionsManifest } from './consultation-submissions';
import { contactLogManifest } from './contact-log';
import { lobbyistRegisterManifest } from './lobbyist-register';
import { positionPapersManifest } from './position-papers';
import { transparencyReportsManifest } from './transparency-reports';

/** Група модулів «Адвокація» (Advocacy): 5 модулів. */
export const advocacyGroup: IModuleGroupManifest = {
  key: 'advocacy',
  category: 'Advocacy',
  name: { en: 'Advocacy', uk: 'Адвокація' },
  sort: 18,
  modules: [consultationSubmissionsManifest, contactLogManifest, lobbyistRegisterManifest, positionPapersManifest, transparencyReportsManifest],
};
